<template>
  <div
    v-show="visible"
    class="msg-frame"
  >
    <div
      class="msg-frame-left"
    >
      <img
        v-if="iconType === 0"
        src="~/public/images/logo/logo-tiny.png"
        class="msg-frame-logo"
      >
      <span
        v-if="iconType"
        :class="['msg-frame-logo', 'team',{'away':iconType ===2}]"
      >{{ teamIcon }}</span>
      <span
        v-if="iconType"
        class="msg-frame-time"
      >{{ matchClock }}</span>
      <div
        v-if="isPushMsg"
        :class="['msg-frame-push',
                 {'has-anim-home':iconType===1,
                  'has-anim-away':iconType===2,
                  'has-anim-default':iconType===0}
        ]"
      />
    </div>
    <div class="msg-frame-right">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MsgFrame',
  props: {
    commentaryType: {
      type: Number,
      default: 0
    },
    team: {
      type: Number,
      default: 0
    },
    matchClock: {
      type: String,
      default: ''
    },
    defaultVisible: {
      type: Boolean,
      default: true
    },
    isPushMsg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: this.defaultVisible
    }
  },
  computed: {
    iconType() {
      // 1 HOME  2 AWAY 0 MSport
      const { commentaryType, team, matchClock } = this
      if (commentaryType === 1 && team && matchClock) return team === 1 ? 1 : 2
      else return 0
    },
    teamIcon() {
      const { iconType } = this
      if (iconType) return iconType === 1 ? 'H' : 'A'
      else return ''
    }
  },
  methods: {
    // 注意该方法会被子组件调用
    open() {
      this.visible = true
    },
    // 注意该方法会被子组件调用
    close() {
      this.visible = false
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.msg-frame {
  display: flex;
  min-height: 58/@rem;
  box-sizing: border-box;
  padding-top: 10/@rem;
  border-bottom: 1px solid #222;
  border-left: 1px solid #222;
  margin: 0 15/@rem 0 27/@rem;
  background: @mask;

  &-left {
    position: relative;
    margin-left: -12/@rem;

    &::before {
      position: absolute;
      top: -10/@rem;
      left: 11/@rem;
      width: 1px;
      height: 10/@rem;
      background-color: #222;
      content: "";
    }
  }

  &-logo {
    display: flex;
    width: 24/@rem;
    align-items: center;
    justify-content: center;
    margin: 0 10/@rem 4/@rem 0;

    &.team {
      display: flex;
      height: 24/@rem;
      align-items: center;
      justify-content: center;
      border-radius: 24/@rem;
      background-color: @major;
      color: #f9751a;
    }

    &.away {
      color: #27b259;
    }
  }

  &-time {
    position: relative;
    display: inline-block;
    width: 24/@rem;
    color: @gray;
    font-size: 8/@rem;
    text-align: center;
  }

  &-right {
    width: 100%;
    flex: 1;
    margin-bottom: 10/@rem;

    &.hide-left {
      border-radius: 4/@rem;
      margin: 0;
      background-color: @major;
    }
  }

  &-push {
    position: absolute;
    z-index: 4;
    top: -10/@rem;
    left: -28/@rem;
    width: 600%;
    height: 100%;
    // 径向渐变
    // background-image: radial-gradient(40% 50% at 0 50%,rgba(249, 117, 26,.3), transparent );
    &.has-anim-home {
      animation: slide_down1 1s ease-in-out forwards;
    }

    &.has-anim-away {
      animation: slide_down2 1s ease-in-out forwards;
    }

    &.has-anim-default {
      animation: slide_down3 1s ease-in-out forwards;
    }
  }
}

@keyframes slide_down1 {
  0% {
    z-index: 4;
    background-image: linear-gradient(150deg, rgba(249, 117, 26, 30%) 4%, transparent 40%);
    opacity: 0;
  }

  50% {
    z-index: 4;
    background-image: linear-gradient(150deg, rgba(249, 117, 26, 30%) 4%, transparent 40%);
    opacity: 1;
  }

  99% {
    z-index: 4;
    background: none;
    opacity: 0;
  }

  100% {
    z-index: -1;
    background: none;
    opacity: 0;
  }
}

@keyframes slide_down2 {
  0% {
    z-index: 4;
    background-image: linear-gradient(150deg, rgba(39, 178, 89, 30%) 4%, transparent 40%);
    opacity: 0;
  }

  50% {
    z-index: 4;
    background-image: linear-gradient(150deg, rgba(39, 178, 89, 30%) 4%, transparent 40%);
    opacity: 1;
  }

  99% {
    z-index: 4;
    background: none;
    opacity: 0;
  }

  100% {
    z-index: -1;
    background: none;
    opacity: 0;
  }
}

@keyframes slide_down3 {
  0% {
    z-index: 4;
    background-image: linear-gradient(150deg, rgba(127, 127, 127, 30%) 4%, transparent 40%);
    opacity: 0;
  }

  50% {
    z-index: 4;
    background-image: linear-gradient(150deg, rgba(127, 127, 127, 30%) 4%, transparent 40%);
    opacity: 1;
  }

  99% {
    z-index: 4;
    background: none;
    opacity: 0;
  }

  100% {
    z-index: -1;
    background: none;
    opacity: 0;
  }
}

</style>
